import {
  WEBWIDGET_SEND_MESSAGE,
  WEBWIDGET_SEND_TEXT_MESSAGE,
} from './constants';

export const sendMessage = (data) => ({
  type: WEBWIDGET_SEND_MESSAGE,
  data,
});

export const sendTextMessage = (data) => ({
  type: WEBWIDGET_SEND_TEXT_MESSAGE,
  data,
});
